var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.gameState.inTreasureHall
    ? _c(
        "div",
        { staticClass: "treasure-modal", on: { click: _vm.closeModal } },
        [
          _c(
            "div",
            {
              staticClass: "treasure-card",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "treasure-tabs" },
                _vm._l(_vm.categories, function (category) {
                  return _c(
                    "button",
                    {
                      key: category.id,
                      class: [
                        "tab-btn",
                        { active: _vm.activeCategory === category.id },
                      ],
                      on: {
                        click: function ($event) {
                          _vm.activeCategory = category.id
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(category.name) +
                          " (" +
                          _vm._s(category.count) +
                          ")\n      "
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "treasure-content" }, [
                _c("div", { staticClass: "shop-section" }, [
                  _c("h4", [
                    _vm._v(_vm._s(_vm.currentCategoryName) + "商品列表"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "shop-items" },
                    _vm._l(_vm.filteredShopItems, function (item) {
                      return _c(
                        "div",
                        {
                          key: item.id,
                          staticClass: "shop-item",
                          class: { unlocked: item.unlocked },
                        },
                        [
                          _c("div", { staticClass: "item-main" }, [
                            _c("div", { staticClass: "item-name" }, [
                              _vm._v(_vm._s(item.name)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "item-meta" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "item-rarity",
                                  class: `rarity-${item.rarity}`,
                                },
                                [_vm._v(_vm._s(item.rarityText))]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "item-type" }, [
                                _vm._v(_vm._s(item.type)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "item-description" }, [
                              _vm._v(_vm._s(item.description)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "item-price-actions" }, [
                            _c("div", { staticClass: "item-price" }, [
                              _vm._v(_vm._s(item.price) + " 灵石"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "item-actions" }, [
                              !item.unlocked
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "purchase-btn",
                                      attrs: {
                                        disabled: !_vm.canAfford(item.price),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.purchaseItem(item)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  购买\n                "
                                      ),
                                    ]
                                  )
                                : _c("div", { staticClass: "unlocked-badge" }, [
                                    _vm._v("已拥有"),
                                  ]),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.filteredShopItems.length === 0
                    ? _c("div", { staticClass: "empty-category" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.currentCategoryName) + "分类暂无商品"
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _vm.showConfirmDialog
                ? _c(
                    "div",
                    {
                      staticClass: "confirm-modal",
                      on: { click: _vm.cancelPurchase },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "confirm-card",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                          },
                        },
                        [
                          _c("h4", [_vm._v("确认购买")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "confirm-content" }, [
                            _c("p", [
                              _vm._v("确定要购买 "),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.pendingPurchase?.name)),
                              ]),
                              _vm._v(" 吗？"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "purchase-details" }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "detail-label" }, [
                                  _vm._v("价格:"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "detail-value" }, [
                                  _vm._v(
                                    _vm._s(_vm.pendingPurchase?.price) + " 灵石"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "detail-label" }, [
                                  _vm._v("当前灵石:"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "detail-value" }, [
                                  _vm._v(_vm._s(_vm.playerSpiritStones)),
                                ]),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "confirm-actions" }, [
                            _c(
                              "button",
                              {
                                staticClass: "cancel-btn",
                                on: { click: _vm.cancelPurchase },
                              },
                              [_vm._v("取消")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "confirm-btn",
                                on: { click: _vm.confirmPurchase },
                              },
                              [_vm._v("确认购买")]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "treasure-footer" }, [
                _c("div", { staticClass: "player-info" }, [
                  _vm._v(
                    "\n        你的灵石: " +
                      _vm._s(_vm.playerSpiritStones) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "close-btn", on: { click: _vm.closeModal } },
                  [_vm._v("离开")]
                ),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "treasure-header" }, [
      _c("h3", [_vm._v("聚宝阁")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("神秘的宝阁，汇聚天下珍宝，你可以用灵石购买各种秘籍和宝物。"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }